<template>
  <div />
</template>

<script>
  export default {
    props: {
      enrollmentState: {
        type: Object,
        required: true
      },
      stepState: {
        type: Object,
        required: true
      },
      participantId: {
        type: Number,
        required: false
      },
      account: {
        type: Object,
        required: false 
      }
    },
    // multiple enrollment states in the mock may use this component
    // but when the state changes but component stays the same, we need to reemit
    // a ready so the EnrollmentApp can remove the loader.
    watch: {
      enrollmentState() {
        // reset data to initial state
        Object.assign(this.$data, this.$options.data.call(this));
        this.init();
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.$emit('ready');
      }
    }
  }
</script>